module.exports = __webpack_public_path__ + "99197c6eb840662ccf76a3874bf3bb62.svg";